/**
 * LeadRiskChips — surface list-level risk flags (Sprint 8.8).
 */

import React from "react";
import { Box, Chip } from "@mui/material";
import { WarningAmber } from "@mui/icons-material";
import { getLeadRiskFlags } from "../services/leadOperationalStatus.js";

const LeadRiskChips = ({ lead, max = 2 }) => {
  const flags = getLeadRiskFlags(lead);
  if (!flags.length) {
    return (
      <Box component="span" sx={{ color: "text.disabled", fontSize: 12 }}>
        —
      </Box>
    );
  }

  const visible = flags.slice(0, max);
  const overflow = flags.length - visible.length;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
      {visible.map((flag) => (
        <Chip
          key={flag.key}
          icon={<WarningAmber sx={{ fontSize: "14px !important" }} />}
          label={flag.label}
          size="small"
          color="warning"
          variant="outlined"
          sx={{ height: 22, fontSize: "0.7rem", maxWidth: 160 }}
        />
      ))}
      {overflow > 0 && (
        <Box component="span" sx={{ fontSize: 11, color: "text.secondary" }}>
          +{overflow} more
        </Box>
      )}
    </Box>
  );
};

export default LeadRiskChips;
